export class Helper {
    static HasValue(value: string | undefined): boolean {
        if (value === undefined || value === "" || value === null)
            return false;

        return true;
    }

    static IsNull(value: string | undefined): boolean {
        if (value === undefined || value === null || value === "")
            return false;

        return true;
    }

    static ToLocalDate(date: Date): string {
        if (typeof (date) == 'string') {
            date = new Date(date);
        }
        const formattedDate = new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "long", // "short" or "2-digit" also possible
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        }).format(date);
        return formattedDate;
    }

    static RemoveDecimal(num: number): string {
        return Number(num).toFixed(0);
    }

    static IsValidPhoneNumber(phoneNumber: string): boolean {
        const phoneNumberPattern = /^09\d{9}$/;
        return phoneNumberPattern.test(phoneNumber);
    }
    
    static async toSHA256(value: string) {
        // 1. Encode the text message into a Uint8Array byte buffer
        const msgBuffer = new TextEncoder().encode(value);

        // 2. Hash the buffer using the native Web Crypto API
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

        // 3. Convert the resulting ArrayBuffer into a byte array
        const hashArray = Array.from(new Uint8Array(hashBuffer));

        // 4. Convert the bytes into a readable hexadecimal string
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        return hashHex;
    }
}